<template>
  <div>
    <div class="dataEchart">
      <div class="dataUse">{{$t('common.dayUseRate')}}</div>
      <el-tabs v-model="activeSelect" @tab-click="handleClick">
        <el-tab-pane :label="$t('common.twentyFourHourSystem')" name="first">
          <div v-if="'first' == activeSelect">
            <linegraph
              v-loading="dayLoading"
              :id="'dayBargraph'"
              :data="dayOption"
              style="height: 313px"
            ></linegraph>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('common.eightHourSystem')" name="second">
          <div v-if="'second' == activeSelect">
            <linegraph
              v-loading="dayLoading"
              :id="'dayBargraph'"
              :data="dayOption"
              style="height: 313px"
            ></linegraph>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="dataTable">
      <el-tabs v-model="activeName" @tab-click="handleChange">
        <el-tab-pane :label="$t('BatteryAnalysis.carUseDetail')" name="first">
          <div v-if="'first' == activeName">
            <div class="rightAll-btn" style="float: right">
              <el-button v-if="isPrimaryKey('VEHICLEANALYSIS_DURATION_MONTH_DOWN')" type="text" @click="downCar"
                >{{$t('common.btn.download')}}</el-button
              >
            </div>
            <i-table
              :list="list"
              ref="carTable"
              @handleSelectionChange="handleSelectionChange"
              :options="option"
              :columns="columns"
              :operates="operates"
            ></i-table>
            <IPagination ref="page" @PageFun="changeSize"></IPagination>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('DriverAnalysis.workHour')" name="second">
          <div v-if="'second' == activeName">
            <linegraph
              v-loading="hourLoading"
              :id="'hourBargraph'"
              :data="hourOption"
              style="height: 313px"
            ></linegraph>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import MonthTime from "./MonthTime";
export default MonthTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>
